





































































































































































































































































import { FRadioGroup, FRadioGroupField, FFormStep, FIcon } from '@fkui/vue';
import { ValidationService, ValidatorName } from '@fkui/logic';
import Vue from 'vue';
import { FMessageBox } from '@fkui/vue';
import { EventBus } from '@/services/MainService/event-bus';
import DataArrayItem from './DataArrayItem';
import BtNumberField from './BtNumberField.vue';
import FkRichtext from 'fk-vue-richtext';

export default Vue.extend({
    name: 'BTBostadstyp',
    components: {
        FRadioGroup,
        FRadioGroupField,
        FMessageBox,
        FFormStep,
        FIcon,
        BtNumberField,
        FkRichtext,
    },
    props: {
        // eslint-disable-next-line vue/require-prop-types
        dataArray: {
            default: () => {
                return [] as string[];
            },
        },
    },
    data() {
        return {
            samboSelectionTextKey: this.$t('btp.preliminar.berakning.ombostaden.etikett.ensam.typavbostad'),
            samboSelectionMessageKey: this.$t('btp.preliminar.berakning.ombostaden.etikett.infovikaninteberakna.ensamboende'),
            id: 'btBostadstyp',
            radioPicked: '',

            /* Hyresrätt */
            costmonthly: '',
            elincluded: '',
            kvm: '',

            /* Bostadsrätt */
            bostadsrattcostmonthly: '',
            bostadsrattelincluded: '',
            bostadsrattkvm: '',
            bostadsrattinterest: '',

            /* Eget hus */
            propertyfee: '',
            huskvm: '',
            interest: '',
            groundrent: '',

            validation: {
                kostnad: {
                    required: { errorMessage: this.$t('SBRV.RW.pengarfalt.etikett.fyllipengarfalt') },
                    minValue: { minValue: 1 },
                    maxValue: { maxValue: 99999 },
                },
                kostnadStor: {
                    minValue: { minValue: 1 },
                    maxValue: { maxValue: 999999 },
                },
                boyta: {
                    minValue: { minValue: 1 },
                    maxValue: { maxValue: 999 },
                },
            },
        };
    },
    watch: {
        radioPicked: function () {
            this.onChange();
            this.onSubmitStep();
            this.$nextTick(this.toggleErrorMessages);
        },
    },
    created() {
        ValidationService.registerValidator({
            name: 'bostadstyp' as ValidatorName,
            validation: () => {
                this.toggleErrorMessages();
                return this.radioPicked !== 'radio-bostadstyp-annan';
            },
        });
    },
    mounted() {
        EventBus.$on('sambo-radio', this.samboClickHandler);
    },
    methods: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        openContainer(toggleIsOpen: any): void {
            this.$emit('on-change-emit-bostad');
            toggleIsOpen();
        },
        onChange() {
            this.$emit('on-change-emit-bostad');
            this.toggleErrorMessages();
        },
        samboClickHandler(selection: boolean): void {
            this.samboSelectionTextKey = selection
                ? this.$t('btp.preliminar.berakning.ombostaden.etikett.ensam.typavbostad')
                : this.$t('btp.preliminar.berakning.ombostaden.etikett.sambo.typavbostad');
            this.samboSelectionMessageKey = selection
                ? this.$t('btp.preliminar.berakning.ombostaden.etikett.infovikaninteberakna.ensamboende')
                : this.$t('btp.preliminar.berakning.ombostaden.etikett.infovikaninteberakna.sammanboende');
            this.onSubmitStep();
        },
        toggleErrorMessages(): void {
            const interval = setInterval(() => {
                const errorList = this.$el.querySelector('.error-list') as HTMLElement;
                const errorIcon = this.$el.querySelector('#radio-bostadstyp .label__message--error') as HTMLElement;
                if (errorList) {
                    clearInterval(interval);
                    if (this.radioPicked === 'radio-bostadstyp-annan') {
                        errorList.style.display = 'none';
                        // eslint-disable-next-line max-depth
                        if (errorIcon) errorIcon.style.display = 'none';
                    } else {
                        errorList.style.display = 'block';
                        // eslint-disable-next-line max-depth
                        if (errorIcon) errorIcon.style.display = 'block';
                    }
                } else if (this.radioPicked !== 'radio-bostadstyp-annan') {
                    clearInterval(interval);
                }
            }, 100);
        },
        minValue(input: string, minValue: number) {
            const inputToNumber: number = parseInt(input, 10);
            return inputToNumber >= minValue;
        },
        onSubmit(): void {
            ValidationService.validateAllElements('btBostadstyp');
            this.$nextTick(this.toggleErrorMessages);
            this.onSubmitStep();
        },
        onSubmitStep() {
            const dataArray: DataArrayItem[] = [];
            if (this.radioPicked === 'radio-bostadstyp-hyresratt') {
                this.onSubmitHyresratt(dataArray);
            } else if (this.radioPicked === 'radio-bostadstyp-bostadsratt') {
                this.onSubmitBostadsratt(dataArray);
            } else if (this.radioPicked === 'radio-bostadstyp-hus') {
                this.onSubmitHus(dataArray);
            }

            this.$root.$emit('on-submit-emit-bostad', dataArray, 'btBostadstyp');
            this.$emit('on-submit-emit-bostad', dataArray, 'btBostadstyp');
        },
        onSubmitHyresratt(dataArray: DataArrayItem[]) {
            dataArray.push(
                {
                    label: this.samboSelectionTextKey,
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.ensam.typavbostad',
                    value: this.$t('btp.preliminar.berakning.ombostaden.etikett.typavbostad.hyresratt'),
                },
                {
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.manadskostnad'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.manadskostnad',
                    value: this.costmonthly,
                },
            );
            if (this.elincluded === 'yes' || this.elincluded === 'no') {
                dataArray.push({
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.hushallsel'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.hushallsel',
                    value: this.elincluded === 'yes' ? 'Ja' : 'Nej',
                });
            }
            if (this.elincluded === 'yes') {
                dataArray.push({
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.boyta'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.boyta',
                    value: this.kvm,
                });
            }
            ValidationService.validateAllElements('bostadstyp-hyresratt');
        },
        onSubmitBostadsratt(dataArray: DataArrayItem[]) {
            dataArray.push(
                {
                    label: this.samboSelectionTextKey,
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.ensam.typavbostad',
                    value: this.$t('btp.preliminar.berakning.ombostaden.etikett.typavbostad.bostadsratt'),
                },
                {
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.manadskostnad'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.manadskostnad',
                    value: this.bostadsrattcostmonthly,
                },
            );
            if (this.bostadsrattelincluded === 'yes' || this.bostadsrattelincluded === 'no') {
                dataArray.push({
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.hushallsel'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.hushallsel',
                    value: this.bostadsrattelincluded === 'yes' ? 'Ja' : 'Nej',
                });
            }
            if (this.bostadsrattelincluded === 'yes') {
                dataArray.push({
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.boyta'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.boyta',
                    value: this.bostadsrattkvm,
                });
            }
            dataArray.push({
                label: this.$t('btp.preliminar.berakning.ombostaden.etikett.rantekostnad'),
                itemId: 'btp.preliminar.berakning.ombostaden.etikett.rantekostnad',
                value: this.bostadsrattinterest,
            });
            ValidationService.validateAllElements('bostadstyp-bostadsratt');
        },
        onSubmitHus(dataArray: DataArrayItem[]) {
            dataArray.push(
                {
                    label: this.samboSelectionTextKey,
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.ensam.typavbostad',
                    value: this.$t('btp.preliminar.berakning.ombostaden.etikett.typavbostad.hus'),
                },
                {
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.fastighetsavgift'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.fastighetsavgift',
                    value: this.propertyfee,
                },
                {
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.boyta'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.boyta',
                    value: this.huskvm,
                },
                {
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.rantekostnad'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.rantekostnad',
                    value: this.interest,
                },
                {
                    label: this.$t('btp.preliminar.berakning.ombostaden.etikett.tomtrattsavgald'),
                    itemId: 'btp.preliminar.berakning.ombostaden.etikett.tomtrattsavgald',
                    value: this.groundrent,
                },
            );
            ValidationService.validateAllElements('bostadstyp-hus');
        },
    },
});
